import type { MessageKey } from './en';
import type { LocaleId } from './locales';
import { de } from './messages/de';
import { es } from './messages/es';
import { fr } from './messages/fr';
import { hi } from './messages/hi';
import { id } from './messages/id';
import { it } from './messages/it';
import { ja } from './messages/ja';
import { pt } from './messages/pt';
import { zh } from './messages/zh';

export type Catalog = Partial<Record<MessageKey, string>>;


const SHARED: Record<LocaleId, Catalog> = {
  'en-US': {},
  'en-GB': {},
  'es-ES': es,
  'es-MX': es,
  'fr-FR': fr,
  'de-DE': de,
  'it-IT': it,
  'pt-BR': pt,
  'hi-IN': hi,
  'id-ID': id,
  'ja-JP': ja,
  'zh-CN': zh,
};

export function catalogFor(locale: LocaleId): Catalog {
  return SHARED[locale];
}
